import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import React from 'react';
import { ComboBoxContext } from "./ComboBoxContext";
import styled from 'styled-components';
import { mergeProps } from '@react-aria/utils';
/**
 * ComboBox editor input
 */

export var ComboBoxInput = function ComboBoxInput(_ref) {
  var children = _ref.children,
      shouldOpenMenuOnFocus = _ref.shouldOpenMenuOnFocus,
      other = _objectWithoutProperties(_ref, ["children", "shouldOpenMenuOnFocus"]);

  var context = React.useContext(ComboBoxContext);

  if (!context) {
    throw new Error('ComboBoxInput must be wrapped in a ComboBox component');
  }

  var child = React.Children.only(children);
  var getInputProps = context.getInputProps,
      inputRef = context.inputRef,
      openMenu = context.openMenu;

  if (!React.isValidElement(child)) {
    throw new Error('The child of ComboboxInput is not a valid react component.');
  }

  var _getInputProps = getInputProps(),
      ref = _getInputProps.ref,
      inputProps = _objectWithoutProperties(_getInputProps, ["ref"]);

  return /*#__PURE__*/React.createElement(InputWrapper, _extends({
    ref: inputRef
  }, other), React.cloneElement(child, _objectSpread({
    ref: ref
  }, mergeProps(inputProps, child.props, {
    onFocus: shouldOpenMenuOnFocus ? openMenu : undefined
  }))));
};
var InputWrapper = styled.div.withConfig({
  displayName: "ComboBoxInput__InputWrapper",
  componentId: "vapor__sc-1uogcoy-0"
})(["display:block;"]);